import { error401Img } from "@/assets";
import { Typography } from "@/components/ui";

const UnAuthorized = () => {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center">
      <img
        src={error401Img}
        alt="404 Not Found"
        className="h-auto max-w-[25%]"
      />
      <Typography variant={"h1"} affects="bold" className="mt-10">
        UNAUTHORIZED
      </Typography>
      <Typography className="mb-6 mt-2">
        The resource requested could not be accessed.
      </Typography>
    </div>
  );
};

export default UnAuthorized;
